/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useLocation } from "react-router";

/* 🧩 COMPONENTS */
import { Button, Input, Label, SelectEquipment, CustomLoading, Pagination, Breadcrumb } from "../../../Components/index.js";

/* 🔗 SERVICE */
import { HistoricServices } from "../../../Services/historicosServices/index.js";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store/index.js";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeHistoricLoadingList } from "../../../Redux/Actions/index.js";

/* 🎨 STYLES */
import { HeaderContainer, BodyContainer, ContainerTable, Table, TableHeader, 
    TableRow, TableCell, ContainerSpinner, NoData, TableCellItem} from "./styles";
import { Container } from "../../styles.js";

/* 🔧 UTILS */
import { isValidStartData, isValidEndData } from "../../../util/validate.js";

const HistoricDetailed = () => {
    const { t } = useTranslation();

    document.title = t("reports.sub-items.history.detailed.document-title");
    const { id } = useParams();

    const navigationFlow =  [
        { text: 'reports', page: null },
        { text: 'history', page: `/historico/${id}` },
        { text: 'details', page: null },
    ]

    const navigate = useNavigate();
    const services = useRef(new HistoricServices())
    const location = useLocation();
    let data1 = location.state?.data1
    let data2 = location.state?.data2

    const [datainicio, setDatainicio] = useState(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10)+'T00:00');
    const [datafim, setDatafim] = useState(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10)+'T23:59:59');

    const isLoadingList = useSelector(state => state.HistoricReducer.isLoadingList)
    const listData = useSelector(state => state.HistoricReducer.listAllData)
    const listPagination = useSelector(state => state.HistoricReducer.pagination)
    const equipaments = useSelector(state => state.HistoricReducer.equipamentList);
    const Cities = useSelector(state => state.HistoricReducer.cities);
    const city = useSelector(state => state.HistoricReducer.city);
    
    function formatarDataParaYMDHMS(data) {
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function formatarDataParaMDHMS(data) {
        let newdata = new Date(data);
        const month = String(newdata.getMonth() + 1).padStart(2, '0');
        const day = String(newdata.getDate()).padStart(2, '0');
        const hours = String(newdata.getHours()).padStart(2, '0');
        const minutes = String(newdata.getMinutes()).padStart(2, '0');
        
        return `${day}/${month} - ${hours}:${minutes}`;
    }
    
    async function getData(){
        store.dispatch(changeHistoricLoadingList(true));
        let startData = formatarDataParaYMDHMS(new Date(datainicio));
        let endData = formatarDataParaYMDHMS(new Date(datafim));
        await services.current.getAllData(id, startData, endData);
        store.dispatch(changeHistoricLoadingList(false));
    }

    useEffect(() => {
        services.current.getEquipamentos();
        services.current.getCities();
    }, [])

    useEffect(() => {
        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            setTimeout(() => {
                services.current.changeCity(id);
            }, 6000);
        }
    }, [id]);

    useEffect(() => {
        async function getData(){
            store.dispatch(changeHistoricLoadingList(true))
            let startData = formatarDataParaYMDHMS(new Date(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10)+'T00:00'))
            let endData = formatarDataParaYMDHMS(new Date(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 16)))
            await services.current.getAllData(id, startData, endData);
            store.dispatch(changeHistoricLoadingList(false))
        }
        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            getData();
        }
    }, [id, data1, data2, t])

    async function changepage(page){
        store.dispatch(changeHistoricLoadingList(true));
        let startData = formatarDataParaYMDHMS(new Date(datainicio));
        let endData = formatarDataParaYMDHMS(new Date(datafim));
        await services.current.getAllData(id, startData, endData, page);
        store.dispatch(changeHistoricLoadingList(false));
    }

    return (
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <HeaderContainer $top>
                    <div className="selects">
                        <SelectEquipment Color={'white'} options={Cities} value={city} onChange={(e) => services.current.filterEquipaments(e.target.value)} />
                        <SelectEquipment Color={'white'} options={equipaments} value={id} onChange={(e) => {
                            if(e.target.value === '' || e.target.value === null || e.target.value === undefined){
                                toast(t("message.select-equipment"), {
                                    position: "top-center",
                                    type: 'info',
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                                return
                            }else{
                                services.current.changeCity(e.target.value);
                                navigate(`/historico/detalhes/${e.target.value}`, {state: {data1: datainicio, data2: datafim}});
                            }
                        }} />
                    </div>
                    <div className="buttons-container">
                        <Button width={'fit-content'} text={t("buttons.general-data")} onClick={()=>{navigate(`/historico/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                        {equipaments.find(equip => equip.id === id)?.type?.id === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5' &&
                            <>
                                <Button width={'fit-content'} text={'Análises'} onClick={() => {
                                    navigate(`/historico/analises/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                                <Button width={'fit-content'} text={'Modo de operação'} onClick={() => {
                                    navigate(`/historico/operacao/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                            </>
                        }
                    </div>
                </HeaderContainer>
                <HeaderContainer>
                    <div>
                        <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datainicio' 
                            name='datainicio' 
                            type="datetime-local" 
                            placeholder={t("inputs.initial-date.placeholder")}
                            value={datainicio}
                            max={datafim}
                            // innerRef={UserField}
                            invalidMessage={t("inputs.initial-date.invalid-message")}
                            validationFunction={(text) => isValidStartData(text, datafim)}
                            onchange={(text) => text && setDatainicio(text)}> 
                        </Input>
                    </div>
                    <div>
                        <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datafim' 
                            name='datafim' 
                            type="datetime-local" 
                            placeholder={t("inputs.final-date.placeholder")}
                            value={datafim}
                            min={datainicio}
                            invalidMessage={t("inputs.final-date.invalid-message")}
                            validationFunction={(text) => isValidEndData(datainicio, text)}
                            onchange={(text) => (text && !isNaN(new Date(text).getTime())) && setDatafim(text)}> 
                        </Input>
                    </div>
                    <Button text={t("buttons.apply")} width={'fit-content'} onClick={() => getData()}/>
                </HeaderContainer>

                <BodyContainer>
                    {isLoadingList ?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    : id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined' &&
                        listData?.data.length > 0 ?
                            <>
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {listData.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {listData?.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {listData.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                        title === 'Auto ajuste' ? parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(5) : item.Values[title] :
                                                                        parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                                <Pagination last_page={listPagination?.last_page} currentpage={listPagination?.current_page} changepage={changepage}/>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.detailed.no-data")}</NoData>
                            </ContainerSpinner>
                    }
                </BodyContainer>
            </Container>
        </>
    );
}

export default HistoricDetailed;
